import { LocationDataGeocoded } from '../location';
import { AppointmentsGroupBy } from './appointments-group-by';

export interface DossierSearchLocation {
  address: LocationDataGeocoded;
  filters: SearchFilters;
}

export interface SearchFilters {
  groupBy: AppointmentsGroupBy;
  period: Period;
  interventionParams: InterventionParams;
}

export interface Period {
  start: number;
  end: number;
}

export interface InterventionParams {
  outsideIntervention: boolean;
  replacementVehicle: boolean;
  fitterIntervention: boolean;
  displayGeneralists: boolean;
  displayGlassSpecialist: boolean;
}
